// @ts-nocheck
import { afterInteraction } from '../common/afterInteraction';

export default defineNuxtPlugin(() => {
  const PIXEL_ID = useRuntimeConfig().public.SNAP_PIXEL_ID || '7f766792-5da6-44ab-aeb0-74ba0585da63';

  if (!window.snaptr) {
    const a = (window.snaptr = function (...args: any[]) {
      if (a.handleRequest) {
        a.handleRequest(...args);
      } else {
        a.queue.push(args);
      }
    });
    a.queue = [];
  }

  window.snaptr('init', PIXEL_ID);

  afterInteraction().then(() => {
    if (!document.querySelector('script[src="https://sc-static.net/scevent.min.js"]')) {
      const r = document.createElement('script');
      r.async = true;
      r.src = 'https://sc-static.net/scevent.min.js';
      document.head.appendChild(r);
    }
  });

  const route = useRoute();

  const snapTrack = (eventName: string, params?: any): void => {
    const ScCid = route.query.ScCid;
    const store = useKegelAnalyticStore();
    window.snaptr('track', eventName, { ...params, ...store.userData, ScCid });
  };

  return {
    provide: {
      snapTrack,
    },
  };
});
